import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '../../../services/common/notification.service';
import {SysGrammarService} from '../../../services/grammar/sys-grammar.service';
import {SystemicGrammarCategoryDto} from '../../../dtos/grammar/sys/systemic-grammar-category-dto';
import {FormOptionsLists} from "../../../shared/FormOptionsLists";
import {SharedService} from "../../../services/common/shared.service";
import {FuncGrammarService} from "../../../services/grammar/func-grammar.service";
import {SelectDialogComponent} from "../../select/select-dialog/select-dialog.component";

export interface DialogData {
  id: number;
  service: SysGrammarService | FuncGrammarService
}

@Component({
    selector: 'app-edit-sys-grammar',
    templateUrl: './new-grammar-category.component.html',
    styleUrls: ['./new-grammar-category.component.scss'],
    standalone: false
})
export class NewGrammarCategoryComponent implements OnInit {

  service: FuncGrammarService | SysGrammarService

  edit: boolean;
  id: number;
  sysGrammarFormGroup: UntypedFormGroup;
  selectedParentCategory: SystemicGrammarCategoryDto;
  displayedColumns = ['edit', 'level', 'name', 'example'];
  formOptionsLists = new FormOptionsLists();
  levelList = this.formOptionsLists.levelList.filter(o => o !== 'NONE');

  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private notificationService: NotificationService, private sysGrammarService: SysGrammarService,
              private _formBuilder: UntypedFormBuilder, private dialog: MatDialog, private sharedService: SharedService,
              private dialogRef: MatDialogRef<NewGrammarCategoryComponent>
  ) {
    this.id = this.injectedData == null ? null : this.injectedData.id;
    this.service = this.injectedData == null ? null : this.injectedData.service
  }

  ngOnInit(): void {
    this.sysGrammarFormGroup = this._formBuilder.group({
      nameCtrl: ['', Validators.required],
      parentCtrl: ['']
    });
    if (this.injectedData !== null) {
      this.edit = true;
      this.service.getCategoryByID(this.injectedData.id).subscribe(c => {
        this.setForm(c);
      }, error => {
        this.notificationService.openSnackBar(error);
      });
    }
    this.sysGrammarFormGroup.get('parentCtrl')?.disable();
  }

  setForm(c: SystemicGrammarCategoryDto) {
    this.sysGrammarFormGroup = this._formBuilder.group({
      nameCtrl: new UntypedFormControl(c.name, [Validators.required]),
      parentCtrl: ['']
    });
    if (c.parent) {
      this.selectedParentCategory = c.parent;
      this.sharedService.toggleAllSelection(this.sysGrammarFormGroup.controls.parentCtrl, [this.selectedParentCategory]);
    }
    this.sysGrammarFormGroup.get('parentCtrl')?.disable();
  }

  selectSystemicGrammarCategory() {
    const dialogRef = this.dialog.open(SelectDialogComponent, {
      data: {
        selectedObjects: this.selectedParentCategory,
        displayedColumns: ['single-select', 'voc-cat-name', 'voc-cat-parent'],
        selectionEntity: 'systemic_grammar_category',
        dialogTitle: 'Überthema auswählen',
        selectionMode: 'single-select',
        excludedId: this.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.length > 0) {
          this.selectedParentCategory = result[0];
          this.sharedService.toggleAllSelection(this.sysGrammarFormGroup.controls.parentCtrl, [this.selectedParentCategory]);
        } else {
          this.selectedParentCategory = null;
          this.sharedService.toggleAllSelection(this.sysGrammarFormGroup.controls.parentCtrl, []);
        }
      }
      this.sysGrammarFormGroup.get('parentCtrl')?.disable();
    });
  }

  saveOrCreateCategory() {
    const category = new SystemicGrammarCategoryDto(
      this.id,
      this.sysGrammarFormGroup.controls.nameCtrl?.value,
      [],
      null,
      this.selectedParentCategory?.id,
      null,
      []
    );
    this.sendCategoryRequest(category);
  }

  sendCategoryRequest(category: SystemicGrammarCategoryDto) {
    if (!this.edit) {
      this.service.createCategory(category).subscribe({
        next: c => {
          this.notificationService.openSnackBar("Thema " + c.name + " erfolgreich gespeichert")
          this.dialogRef.close(c);
        }, error: error => {
          this.notificationService.openSnackBar(error);
        }
      });
    } else {
      this.service.updateCategory(category).subscribe({
        next: c => {
          this.notificationService.openSnackBar("Thema " + c.name + " erfolgreich aktualisiert");
          this.dialogRef.close(c);
        }, error: error => {
          this.notificationService.openSnackBar(error);
        }
      });
    }
  }
}
